import {
  bus,
  car,
  call,
  crop,
  link,
  star,
  text,
  mail,
  walk,
  boat,
  brush,
  train,
  close,
  flash,
  camera,
  people,
  person,
  subway,
  business,
  checkbox,
  navigate,
  addCircle,
  arrowBack,
  arrowRedo,
  arrowUndo,
  caretBack,
  checkmark,
  construct,
  cogOutline,
  eyeOutline,
  lockClosed,
  mapOutline,
  addOutline,
  micOutline,
  callOutline,
  cashOutline,
  chevronBack,
  closeCircle,
  cloudUpload,
  codeWorking,
  copyOutline,
  exitOutline,
  homeOutline,
  linkOutline,
  mailOutline,
  openOutline,
  saveOutline,
  cubeOutline,
  starOutline,
  arrowForward,
  brushOutline,
  caretForward,
  closeOutline,
  documentText,
  globeOutline,
  trashOutline,
  listOutline,
  timeOutline,
  syncOutline,
  attachOutline,
  cameraOutline,
  cloudDownload,
  createOutline,
  ellipseOutline,
  expandOutline,
  hammerOutline,
  searchOutline,
  pencilOutline,
  peopleOutline,
  personOutline,
  cloudyOutline,
  chatboxOutline,
  checkmarkSharp,
  chevronForward,
  documentAttach,
  desktopOutline,
  refreshOutline,
  warningOutline,
  arrowUpOutline,
  checkmarkCircle,
  contractOutline,
  languageOutline,
  locationOutline,
  businessOutline,
  trashBinOutline,
  settingsOutline,
  arrowDownCircle,
  calendarOutline,
  checkmarkOutline,
  chevronUpOutline,
  clipboardOutline,
  addCircleOutline,
  arrowBackOutline,
  arrowDownOutline,
  cloudDoneOutline,
  arrowUndoOutline,
  chevronDownCircle,
  helpCircleOutline,
  listCircleOutline,
  syncCircleOutline,
  informationCircle,
  alertCircleOutline,
  chevronDownOutline,
  closeCircleOutline,
  cloudUploadOutline,
  arrowForwardOutline,
  checkmarkDoneCircle,
  cloudOfflineOutline,
  documentTextOutline,
  personCircleOutline,
  removeCircleOutline,
  returnUpBackOutline,
  calendarClearOutline,
  cloudDownloadOutline,
  chevronForwardOutline,
  documentAttachOutline,
  checkmarkCircleOutline,
  chatboxEllipsesOutline,
  returnUpForwardOutline,
  chevronDownCircleOutline,
  arrowForwardCircleOutline,
  notificationsCircleOutline,
  informationCircleOutline,
} from "ionicons/icons";
import { addIcons } from "ionicons";

// Register all icons globally
export function registerAppIcons() {
  addIcons({
    call,
    star,
    link,
    crop,
    text,
    mail,
    close,
    brush,
    flash,
    camera,
    person,
    people,
    business,
    navigate,
    checkbox,
    checkmark,
    addCircle,
    construct,
    arrowBack,
    caretBack,
    arrowUndo,
    arrowRedo,
    cogOutline,
    eyeOutline,
    micOutline,
    mapOutline,
    lockClosed,
    addOutline,
    cubeOutline,
    callOutline,
    mailOutline,
    homeOutline,
    cashOutline,
    closeCircle,
    starOutline,
    saveOutline,
    exitOutline,
    chevronBack,
    openOutline,
    cloudUpload,
    codeWorking,
    copyOutline,
    linkOutline,
    trashOutline,
    closeOutline,
    documentText,
    brushOutline,
    caretForward,
    arrowForward,
    globeOutline,
    listOutline,
    cameraOutline,
    personOutline,
    expandOutline,
    pencilOutline,
    createOutline,
    peopleOutline,
    hammerOutline,
    searchOutline,
    cloudDownload,
    cloudyOutline,
    warningOutline,
    checkmarkSharp,
    chevronForward,
    documentAttach,
    refreshOutline,
    chatboxOutline,
    desktopOutline,
    languageOutline,
    calendarOutline,
    checkmarkCircle,
    locationOutline,
    businessOutline,
    settingsOutline,
    contractOutline,
    trashBinOutline,
    arrowDownCircle,
    addCircleOutline,
    checkmarkOutline,
    cloudDoneOutline,
    arrowBackOutline,
    clipboardOutline,
    chevronUpOutline,
    arrowDownOutline,
    helpCircleOutline,
    chevronDownCircle,
    listCircleOutline,
    syncCircleOutline,
    cloudUploadOutline,
    closeCircleOutline,
    chevronDownOutline,
    alertCircleOutline,
    cloudOfflineOutline,
    removeCircleOutline,
    documentTextOutline,
    personCircleOutline,
    checkmarkDoneCircle,
    arrowForwardOutline,
    calendarClearOutline,
    cloudDownloadOutline,
    chevronForwardOutline,
    documentAttachOutline,
    checkmarkCircleOutline,
    chatboxEllipsesOutline,
    chevronDownCircleOutline,
    arrowForwardCircleOutline,
    notificationsCircleOutline,
    car,
    walk,
    timeOutline,
    syncOutline,
    arrowUpOutline,
    arrowUndoOutline,
    informationCircle,
    returnUpBackOutline,
    returnUpForwardOutline,
    ellipseOutline,
    bus,
    boat,
    train,
    subway,
    informationCircleOutline,
  });
}
